export default __webpack_public_path__ + "static/media/furious-bowser.14d0193d.webp";